define('views/base/item_page_view',['require','backbone','marionette','jquery-validation','select2'],function(require){

    var Backbone = require('backbone');
    require('marionette');
    require('jquery-validation');
    require('select2');

    return Backbone.Marionette.LayoutView.extend({
        // html template for the view
        className: 'page',

        initialize: function () {


            if (this.titleKey) {
                App.context.changePageTitle(App.polyglot.t(this.titleKey));
            }

            _.bindAll(this, 'formChanged');

            if (this.afterInitialize) {
                this.afterInitialize();
            }
        },

        ui: function() {
            return {
                select2Input: '[data-init-plugin="select2"]',

                mainForm : '#main-form',
                submitButton: '#submit-button'
            };
        },

        events: {
            'change form input': 'formChanged',
            'change form textarea': 'formChanged',
            'change form select': 'formChanged',

            'click @ui.submitButton': 'submitButtonClicked'
        },

        onRender: function () {

            this.ui.select2Input.select2();

            this.setupFormValidation();

            if (this.afterRender) {
                this.afterRender();
            }
        },

        setupFormValidation: function () {

        },

        formChanged: function (event) {
            var changedField = event.currentTarget;
            var value = $(event.currentTarget).val();
            var valueObject;
            
            if (changedField.id) {

                var changeObject = {};


                // Transform value if necessary
                if ($(changedField).attr('data-key')) {
                    if ($(changedField).attr('multiple')) {
                        if (value) {
                            for (var i=0; i<value.length; i++) {
                                valueObject = {};
                                valueObject[$(changedField).attr('data-key')] = value[i];
                                value[i] = valueObject;
                            }
                        }
                    } else {
                        valueObject = {};
                        valueObject[$(changedField).attr('data-key')] = value;
                        
                        value = valueObject;
                    }
                    changeObject[changedField.id] = value;
                }else if (changedField.type == 'checkbox') {
                    if (changedField.id.indexOf('__') > -1) {
                        var checkFieldKeys = changedField.id.split('__');

                        // TODO: Not proud of this
                        if (checkFieldKeys.length === 2) {
                            changeObject[checkFieldKeys[0]] = this.model.get(checkFieldKeys[0]);
                            changeObject[checkFieldKeys[0]][checkFieldKeys[1]] = changedField.checked;
                        } else if (checkFieldKeys.length === 3) {
                            changeObject[checkFieldKeys[0]] = this.model.get(checkFieldKeys[0]);
                            changeObject[checkFieldKeys[0]][checkFieldKeys[1]] = this.model.get(checkFieldKeys[0])[checkFieldKeys[1]];
                            changeObject[checkFieldKeys[0]][checkFieldKeys[1]][checkFieldKeys[2]] = changedField.checked;
                        }

                    } else {
                        changeObject[changedField.id] = changedField.checked;
                    }
                    
                }else if (changedField.type == 'radio'){
                    // TODO: Not proud of this
                    var fieldRadioKeys = changedField.id.split('__');
                    changeObject[fieldRadioKeys[1]] = value;
                } else {
                    if (changedField.id.indexOf('__') > -1) {
                        var fieldKeys = changedField.id.split('__');

                        // TODO: Not proud of this
                        if (fieldKeys.length === 2) {
                            changeObject[fieldKeys[0]] = this.model.get(fieldKeys[0]);
                            changeObject[fieldKeys[0]][fieldKeys[1]] = _.escape(value);
                        } else if (fieldKeys.length === 3) {
                            changeObject[fieldKeys[0]] = this.model.get(fieldKeys[0]);
                            changeObject[fieldKeys[0]][fieldKeys[1]] = this.model.get(fieldKeys[0])[fieldKeys[1]];
                            changeObject[fieldKeys[0]][fieldKeys[1]][fieldKeys[2]] = _.escape(value);
                        }

                    } else {
                        changeObject[changedField.id] = _.escape(value);
                    }
                }

                this.model.set(changeObject);

            }
        },

        beforeSubmit: function() {
            return true;
        },

        submitButtonClicked: function () {
            var _this = this;

            if (this.ui.mainForm.valid()) {
                if (this.beforeSubmit) {
                    if (!this.beforeSubmit()) {
                        return false;
                    }
                }

                this.ui.submitButton.addClass('loading');
                var isCreate = _this.model.get('id') === null;

                this.model.save(null, {
                    success: function (model, response, options) {
                        _this.ui.submitButton.removeClass('loading');

                        // Reload if created new reseller
                        if (_this.afterSuccess) {
                            _this.afterSuccess(response);
                        } else {
                            if (isCreate) {
                                App.context.redirect('/' + _this.basePath + '/' + model.get('id'));

                                App.utils.showMessage('success', App.polyglot.t('create_success'));
                            } else {
                                App.utils.showMessage('success', App.polyglot.t('update_success'));
                            }
                        }
                    },
                    error: function (model, response, options) {
                        _this.ui.submitButton.removeClass('loading');

                        // Show error messages
                        if (response.responseJSON.errors) {
                            for (var i=0; i<response.responseJSON.errors.length; i++) {
                                App.utils.showMessage('error', response.responseJSON.errors[i].message);
                            }
                        }
                    }
                });

            }
        }


    });
});

